import { IUser } from '@giphy/js-types'
import { map } from 'lodash'
import React, { PureComponent } from 'react'
import { getSuggestedSearchTerms } from 'shared/api/index'
import Tag from 'shared/components/tags/simpleTag'
import { suggestedTermPingBackEvent } from 'shared/pingbacks/pingback-networking'

type Props = {
    term: string
    css: any
    isSticker: boolean
    isMobile: boolean
    user: IUser
}
type Term = {
    name: string
}
type State = {
    suggestedTerms: Term[]
    responseId: string
}
export default class SuggestedTerms extends PureComponent<Props, State> {
    state = { suggestedTerms: [], responseId: '' }

    async getTerms() {
        try {
            const { data: suggestedTerms, meta } = await getSuggestedSearchTerms(this.props.term)
            this.setState({ suggestedTerms, responseId: meta.response_id })
        } catch (e) {
            console.error(e)
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.term !== this.props.term) {
            this.getTerms()
        }
    }

    componentDidMount() {
        this.getTerms()
    }

    render() {
        const { css, isSticker, user } = this.props
        const { responseId } = this.state
        const terms = this.state.suggestedTerms
        const googleAnalytics = {
            category: 'Search',
            action: 'Related Tag Click	',
        }
        if (!terms.length) return <div className={css.sparseTermState} />
        return (
            <div className={css.termSuggestionContainer}>
                <div className={css.suggestions}>
                    {map(terms, (item: Term, index) => (
                        <Tag
                            index={index}
                            name={item.name}
                            isSticker={isSticker}
                            key={index}
                            analytics={googleAnalytics}
                            pingbackAnalytics={{
                                component: 'SUGGESTED_SEARCH',
                                user: user,
                                data: [{ key: 'suggest_term', value: item.name }],
                                pingbackRequest: suggestedTermPingBackEvent,
                                searchResponseId: responseId,
                                needToCheckForOverflow: true,
                                actionNames: {
                                    seen: 'SUGGESTED_SEARCH_SEEN',
                                    click: 'SUGGESTED_SEARCH_CLICK',
                                    hover: 'SUGGESTED_SEARCH_HOVER',
                                },
                            }}
                        />
                    ))}
                </div>
            </div>
        )
    }
}
